import { render } from "./ModalPromo.vue?vue&type=template&id=5d1fa5ae"
import script from "./ModalPromo.vue?vue&type=script&lang=js"
export * from "./ModalPromo.vue?vue&type=script&lang=js"

import "./ModalPromo.vue?vue&type=style&index=0&id=5d1fa5ae&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__